import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography, { type TypographyProps } from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material/styles';

type Props = {
  children: ReactNode;
  action?: ReactNode;
  variant?: TypographyProps['variant'];
  sx?: SxProps<Theme>;
};

const SectionHeader = ({ children, action, variant = 'h2', sx: sxProp }: Props) => (
  <Box
    sx={[
      {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mt: 3,
        mb: 2,
      },
      ...(Array.isArray(sxProp) ? sxProp : sxProp ? [sxProp] : []),
    ]}
  >
    <Typography variant={variant} sx={{ m: 0, p: 0 }}>
      {children}
    </Typography>
    {action}
  </Box>
);

export default SectionHeader;
